import { QueryClient } from "@tanstack/react-query";

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  });

let queryClient;

export const getQueryClient = () => {
  if (!queryClient) {
    queryClient = createQueryClient();
  }

  return queryClient;
};
